import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import PartDuplicateList from './duplicateList';

@withText(props => ({
    partNumber: <Text id='input.partNumber-help'>partNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewPart extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('part'),
            duplicates: [],
            duplicatesAiChecked: false,
            checkingDuplicates: false,
            creatingPart: false,
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id, installationId } = props;
        const { partStore } = this.props.stores;
        if (emptyFirst) {
            partStore.updateKeyValue('part', {});
        }
        if (id) {
            await partStore.load(id, false, { addData: ['installations'], query: { installationId } });
        }
    }

    createPart = async () => {
        const { partStore } = this.props.stores;
        const { newPart } = partStore;

        if (!newPart.partNumber) {
            partStore.updateObjectKeyValue('newPart', 'partNumber', newPart.name);
        }
        if (newPart.id) {
            // Picked from the "Similar parts" search list: keep updating that part.
            await partStore.save({ ...newPart });
            await this.finishWithPart(newPart);
            return;
        }

        // Let the AI look for the same item among existing parts before creating it.
        this.setState({ checkingDuplicates: true });
        const response = await partStore.duplicateCheck(newPart);
        const duplicates = response?.status === 200 && Array.isArray(response.data?.duplicates)
            ? response.data.duplicates : [];
        this.setState({ checkingDuplicates: false });
        if (duplicates.length > 0) {
            this.setState({
                duplicates,
                duplicatesAiChecked: response.data.aiChecked === true,
            });
            return;
        }
        await this.insertNewPart();
    }

    insertNewPart = async () => {
        const { partStore } = this.props.stores;
        this.setState({ creatingPart: true });
        const response = await partStore.insert(partStore.newPart);
        this.setState({ creatingPart: false });
        await this.finishWithPart(response?.data?.part);
    }

    useExisting = async id => {
        const { callback = () => {}, installation, drawerLevel = 1 } = this.props;
        const { appState, partStore } = this.props.stores;
        const { duplicates } = this.state;
        const part = duplicates.find(dup => dup.id === id);
        if (!part) {
            return;
        }
        if (installation?.id) {
            await this.finishWithPart(part);
            return;
        }
        partStore.updateKeyValue('newPart', {});
        this.setState({ duplicates: [] });
        callback();
        appState.openDrawer('viewPart', {
            id: part.id,
            height: appState.drawerHeightMedium,
        }, drawerLevel);
    }

    backToEditing = () => {
        this.setState({ duplicates: [] });
    }

    finishWithPart = async part => {
        const { callback = () => {}, installation } = this.props;
        const { partStore, installationStore } = this.props.stores;
        if (installation?.id) {
            const newObject = {
                qty: 1,
                id: part.id,
                name: part.name,
                partNumber: part.partNumber,
            };
            await installationStore.addArrayObject({
                newObject,
                object: installation,
                field: 'parts',
                // objectName: 'installation',
            });
        }
        partStore.updateKeyValue('newPart', {});
        this.setState({ duplicates: [] });
        callback();
    }

    chooseItem = (e) => {
        const { id } = e.target.closest('.similar-item').dataset;
        const { partStore } = this.props.stores;
        const { foundList } = partStore;
        const item = foundList.find((item) => item.id === parseInt(id, 10));
        partStore.updateKeyValue('newPart', {
            ...item,
        });
        partStore.resetSearch();
    }

    toggleSimilar = () => {
        const { showSimilar } = this.state;
        this.setState({
            showSimilar: !showSimilar,
        });
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { week, isNew, drawerLevel, installation, lookupArray = 'parts' } = this.props;
        const {
            sections, showSimilar, duplicates, duplicatesAiChecked, checkingDuplicates, creatingPart,
        } = this.state;
        const { userStore, partStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newPart, foundList, foundListKeys } = partStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const showDuplicates = duplicates.length > 0;

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(installation, null, 4)}</xmp> */}

                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='part.new'>New part</Text> : <Text id='part.edit'>Edit part</Text>}
                        {installation?.id && <>
                            <span class='ms-2'>
                                :: {installation.name}
                            </span>
                        </>}
                    </div>

                    {showDuplicates && <PartDuplicateList
                        duplicates={duplicates}
                        aiChecked={duplicatesAiChecked}
                        busy={creatingPart}
                        onUse={this.useExisting}
                        onCreateAnyway={this.insertNewPart}
                        onBack={this.backToEditing}
                    />}

                    {!showDuplicates && showSimilar && foundList?.length > 0 && <>
                        <div class='w-100 d-flex flex-column justify-content-start'>
                            <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                                <div class='mx-4 font-weight-lighter px-3 py-1 text-muted' >
                                    <small class='text-uppercase'>
                                        <Text id='part.similar'>Similar parts</Text>
                                    </small>
                                </div>
                                <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-4 d-flex flex-column px-0 overflow-auto`} style='font-size: 1.1em; border-radius: 10px; max-height: 35vh;'>
                                    {foundList.map((item, idx) => {
                                        return(<>
                                            <div class='d-flex flex-row justify-content-between align-items-center'>
                                                <div
                                                    class='flex-fill similar-item py-2 px-3'
                                                    data-id={item.id}
                                                    onClick={this.chooseItem}
                                                >
                                                    {item.name}
                                                    <span class='font-weight-lighter text-muted ms-3'>{item.partNumber}</span>
                                                </div>
                                                {/* {item.images[0] && <>
                                                    <div>
                                                        <div class=''>
                                                            <img src={`${item.images[0].s3MediumLink}`} class='rounded-lg img-fluid' style='max-height: 45px;' />
                                                        </div>
                                                    </div>
                                                </>} */}
                                            </div>
                                        </>);
                                    })}
                                </div>
                            </div>
                        </div>
                    </>}

                    {!showDuplicates && <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={partStore}
                                objectName={isNew ? 'newPart' : 'part'}
                                isNew={isNew}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                lookupArray={lookupArray}
                                rightHeader={isNew && foundList?.length > 0 ? <span class='text-success font-weight-bold'><i class='fa-solid fa-circle-info' /> Similar parts ({foundList.length})</span> : null}
                                rightHeaderClick={this.toggleSimilar}
                            />
                        </div>
                    </div>}
                </div>



            </div>

            {isNew && !showDuplicates && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                <button type='button' class='btn btn-primary rounded-pill' onClick={this.createPart} disabled={checkingDuplicates || creatingPart}>
                    {checkingDuplicates ? <>
                        <i class='fa-solid fa-spinner fa-spin me-2' />
                        <Text id='part.checking-duplicates'>Checking for duplicates...</Text>
                    </> : <>
                        {isNew ? <Text id='part.create'>Create part</Text> : <Text id='part.save'>Save part</Text>}
                    </>}
                </button>
            </div>}
        </>);
    }
}

export default NewPart;
